import { InjectionToken } from '@angular/core';
import { AlternativeProducts, Product } from '../../../model';
import { Occ } from '../../../occ';
import { Converter } from '../../../util/converter.service';

export const PRODUCT_NORMALIZER = new InjectionToken<Converter<Occ.Product, Product>>('ProductNormalizer');
export const SUBSTITUTE_PRODUCTS_NORMALIZER = new InjectionToken<Converter<Occ.AlternativeProducts, AlternativeProducts>>(
  'SubstituteProductsNormalizer'
);
